import { z } from "zod";

export const handshakeQuerySchema = z.object({
  clientId: z.string(),
  clientName: z.string().nullish(),
  clientImage: z.string().nullish(),
  roomId: z.string(),
  // Skip the SYNC handshake (no doc init, no full state transfer). Useful for
  // pages that only want to receive room broadcasts (e.g. payment flow).
  listenerOnly: z.literal('1').optional(),
});
export type HandshakeQuery = z.infer<typeof handshakeQuerySchema>;

export type AckResponse =
  | { status: "success" }
  | { status: "error"; message: string };
export type AckCallback = (res: AckResponse) => void;

export const isBuffer = (bytes: unknown): bytes is Uint8Array | ArrayBuffer => {
  return bytes instanceof Uint8Array || bytes instanceof ArrayBuffer;
};
export const bufferToUint8Array = (bytes: Uint8Array | ArrayBuffer) => {
  return bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
};

export const updateRequestSchema = z.object({
  main: z.any(),
  temp: z.any(),
  instant: z.boolean(),
  contributorId: z.number().int().optional(),
});
export type UpdateRequest = z.infer<typeof updateRequestSchema>;

export const updateResponseSchema = z.object({
  bytes: z.object({
    main: z
      .any()
      .optional(),
    temp: z
      .any()
      .optional(),
  }),
  senderId: z.string().optional(),
  cursor: z.string().optional(),
});
export type UpdateResponse = z.infer<typeof updateResponseSchema>;
